import Button from "@/Components/Button/Button";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useUserSettingsHook from "../../shared/hooks/useUserSettingsHook";
import Boolean from "../Boolean/BooleanWithLabel";
import Modal, { ModalProps } from "./Modal";
import ModalTitle from "./ModalTitle";

const AutoAcceptOrderModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation();
  const { query, putUserSettings } = useUserSettingsHook();
  const queryClient = useQueryClient();
  const [isActive, setIsActive] = useState(false);
  const { handleSubmit } = useForm();

  const onSubmit = () => {
    const { item_id, is_tip_shown_in_live_tracker, ...restData } = query?.data;
    const submitData = {
      ...restData,
      is_active: isActive,
    };
    putUserSettings.mutateAsync(submitData, {
      onSuccess: (data) => {
        queryClient.setQueryData(["orderTracker"], data);
        onExit();
      },
    });
  };

  return (
    <Modal width="40rem" {...props}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalTitle mb="2rem" p="0"></ModalTitle>
        <div className="mb-[2rem]">
          <h4>{t("orders_live.activateMessage")}</h4>
          <Boolean
            onChange={(e) => setIsActive(e.target.checked)}
            checked={isActive}
          >
            {t("orders_live.active")}
          </Boolean>
        </div>
        <div className="flex justify-end">
          <Button
            isDisabled={!isActive}
            type="submit"
            isPending={putUserSettings.isPending}
          >
            {t("orders_live.save")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AutoAcceptOrderModal;
